import React from 'react';
import { useHybridAuth } from '../HybridAuthProvider';

interface TenantNotAuthorizedProps {
  userEmail?: string;
  organization?: string;
}

const TenantNotAuthorized: React.FC<TenantNotAuthorizedProps> = ({ userEmail, organization }) => {
  const { logout } = useHybridAuth();

  const handleLogout = () => {
    logout();
  };

  // Extract organization name from email if possible
  const orgName =
    organization ||
    (userEmail && userEmail.includes('@')
      ? userEmail.split('@')[1].split('.')[0] // Get domain part before .com/.org
      : 'Your organization');

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '2rem',
        textAlign: 'center',
        backgroundColor: '#f5f5f5',
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '3rem',
          maxWidth: '600px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        }}
      >
        <h1 style={{ color: '#2c3e50', marginBottom: '1.5rem' }}>Organization Not Registered</h1>

        <div style={{ marginBottom: '2rem' }}>
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"
              fill="#e74c3c"
            />
          </svg>
        </div>

        {userEmail && (
          <p style={{ color: '#7f8c8d', marginBottom: '2rem', fontWeight: '500' }}>
            {userEmail}
          </p>
        )}

        <div
          style={{
            backgroundColor: '#fff5f5',
            borderLeft: '4px solid #e74c3c',
            borderRadius: '4px',
            padding: '1.5rem',
            marginBottom: '2rem',
            textAlign: 'left',
          }}
        >
          <h3 style={{ marginTop: 0, marginBottom: '1rem', color: '#c0392b' }}>
            {orgName} is not yet registered with HabiTrack
          </h3>

          <p style={{ marginBottom: '1rem', color: '#2c3e50' }}>
            Your organization has not yet signed up for HabiTrack's workplace habit and culture transformation
            programmes.
          </p>

          <p style={{ color: '#2c3e50', fontWeight: '500' }}>If you believe this is an error:</p>

          <ul style={{ marginLeft: '1.5rem', color: '#2c3e50' }}>
            <li>Contact your HR department or Learning & Development team</li>
            <li>Reach out to your programme manager if you've been invited to a specific programme</li>
            <li>Check if you're using the correct corporate email address</li>
          </ul>
        </div>

        <div
          style={{
            backgroundColor: '#f0f9ff',
            borderRadius: '4px',
            padding: '1.5rem',
            marginBottom: '2rem',
            textAlign: 'left',
          }}
        >
          <h4 style={{ marginTop: 0, marginBottom: '0.5rem', color: '#2980b9' }}>
            Interested in HabiTrack for your organization?
          </h4>
          <p style={{ color: '#34495e', marginBottom: 0 }}>
            HabiTrack helps organizations build positive workplace cultures through science-based habit formation
            programmes. Our enterprise solutions are designed for teams and entire organizations.
          </p>
        </div>

        <div style={{ marginTop: '2rem' }}>
          <button
            onClick={handleLogout}
            style={{
              backgroundColor: '#3498db',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '4px',
              border: 'none',
              fontWeight: '500',
              cursor: 'pointer',
              marginRight: '1rem',
            }}
          >
            Login as Different User
          </button>

          <a
            href="https://www.fabricshift.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              backgroundColor: '#95a5a6',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '4px',
              textDecoration: 'none',
              fontWeight: '500',
            }}
          >
            Learn More About FabricShift
          </a>
        </div>
      </div>
    </div>
  );
};

export default TenantNotAuthorized;
